(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["more-from-artist"] && !Shopify.designMode) return;
  try {
    
  class MoreFromArtist extends HTMLElement {
    async connectedCallback() {
      const { query, prefix, current, limit, moneyFormat } = this.dataset;
      const url = `${window.Shopify?.routes?.root || '/'}search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=last`;
      let products = [];
      try {
        const response = await fetch(url);
        if (!response.ok) return;
        products = (await response.json()).resources?.results?.products || [];
      } catch {
        return;
      }

      const lead = `${prefix} - `.toLowerCase();
      const matches = products
        .filter((p) => p.handle !== current && p.title.toLowerCase().startsWith(lead))
        .slice(0, Number(limit) || 6);
      if (!matches.length) return;

      // Match the store's own price display (shop.money_format, e.g. "R <amount>"):
      // swap its double-brace amount placeholder for the formatted number.
      const money = {
        format: (value) => {
          const amount = value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
          return moneyFormat ? moneyFormat.replace(/\{\{?\s*\w+\s*\}\}?/, amount) : amount;
        },
      };
      const list = this.querySelector('.more-from-artist__list');
      for (const p of matches) {
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.className = 'more-from-artist__card';
        link.href = p.url;

        if (p.featured_image?.url || p.image) {
          const img = document.createElement('img');
          img.className = 'more-from-artist__image';
          img.src = `${p.featured_image?.url || p.image}${(p.featured_image?.url || p.image).includes('?') ? '&' : '?'}width=300`;
          img.alt = p.featured_image?.alt || p.title;
          img.loading = 'lazy';
          img.width = 300;
          img.height = 300;
          link.append(img);
        }

        const title = document.createElement('span');
        title.className = 'more-from-artist__title';
        title.textContent = p.title.slice(lead.length);
        link.append(title);

        const price = document.createElement('span');
        price.className = 'more-from-artist__price';
        if (p.available === false) {
          price.classList.add('more-from-artist__price--sold-out');
          price.textContent = 'Sold out';
        } else {
          price.textContent = money.format(Number(p.price));
        }
        link.append(price);

        item.append(link);
        list.append(item);
      }
      this.hidden = false;
    }
  }

  if (!customElements.get('more-from-artist')) {
    customElements.define('more-from-artist', MoreFromArtist);
  }

  } catch(e) { console.error(e); }
})();
})();
